/* eslint-disable */
/* this file is generated by generateIcons script */
import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ListViewIcon extends BaseIcon {
  getChildren = () => [
    <rect fill={this.getColor()} x="1" y="6" width="14" height="1"/>,
    <rect fill={this.getColor()} x="1" y="1" width="14" height="2"/>,
    <rect fill={this.getColor()} x="1" y="10" width="14" height="1"/>,
    <rect fill={this.getColor()} x="1" y="14" width="14" height="1"/>
  ];
  getViewBox = () => '0 0 16 16'
}
